import React from "react";
import FormInput from "Common/Custom/FormInput";
import Switch from "Common/Custom/Switch";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

/**
 * MenuEditForm Component
 * Renders the form fields for updating a front menu item.
 */
const MenuEditForm = ({
  fields: formdata = [],
  values,
  errors,
  handleChange,
  handleSubmit,
  loading,
  title = "Update Menu Setting"
}) => {
  return (
    <PageBody 
      onSubmit={handleSubmit} 
      headerchildren={<HeadingOne>{title}</HeadingOne>}
    >
      {formdata.map((field) => {
        // Handle Switch/Toggle fields
        if (field.type === "switch") {
          return (
            <Switch
              key={field.name}
              values={values[field.name]}
              handleChange={handleChange}
              field={field}
              ValueOne="1"
              ValueTwo="0"
              LabelOne="Active"
              LabelTwo="Inactive"
            />
          );
        }

        // Default: Render Standard Text Input
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      <FormSubmitButton
        label='Update'
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default MenuEditForm;
